
    import { defineComponent } from 'vue'
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import ProductCardsSelector from '@/apps/shared/components/ProductCardsSelector.vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import travelAssistanceService from '@/apps/shared/services/travelAssistance-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    export default defineComponent({
        name: 'travelAssistance-destination',
        components: {
            XBreadcrumb,
            ProductCardsSelector
        },
        busEvents: {
            Next: function (data) {
                //prevenir que el evento Next y otras acciones de navegación se ejecuten de forma redundante.
                if (data.fromTab === 'travel-destination') {
                    if (this.$refs.productCards && this.$refs.productCards.isNavigationAllowed) {  // Comprobamos si la navegación está permitida
                        this.$router.push({
                            name: 'travelAssistance-trip-type',
                        });
                        this.$refs.productCards.isNavigationAllowed = false;  // Desactivamos la navegación
                    }
                }
            },
            SaveProductDataValueSession: function (value) {
                if (value.fromTab === 'travel-destination') {
                    // La pantalla siguiente (tipo de viaje) exige esta key en su guard:
                    // sin ella rebota de vuelta a esta pantalla
                    sessionStorage.setItem('TravelDestinationSelected', JSON.stringify(value));
                }
            },
        },

        data() {
            return {
                productCardsSelector: {
                    iconPromotion: null,
                    otherIconPromotion: null,
                    icon: null,
                    product: "",
                    title: "¿A dónde viajás?",
                    subTitle: "Elegí el destino de tu viaje.",
                    tabName: "travel-destination",
                } as TitleAndPromotionsDetails,
                breadcrumItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: '¿A dónde viajás?', path: '/asistencia-viajero/destino' },
                ],
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            async getDestinations() {
                const destinations = await travelAssistanceService.getDestination();
                const items = destinations.map(element => ({
                    ...element,
                    code: element.id,
                    productDescription: element.description,
                    hasProductNoteValue: false,
                }));
                this.$refs.productCards.setProductData(items);
            },

            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'travelAssistance-tab-One',
                })
            },

            async getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                // Guard: sin datos personales cargados no hay flujo válido
                if (sessionStorage.getItem("DataTabHome") == null) {
                    this.$router.push({ name: 'travelAssistance-tab-One' });
                    return;
                }

                // Consumir pressBack ANTES del fetch: si el servicio falla no debe quedar colgado
                var pressBack = sessionStorage.getItem("pressBack");
                if (pressBack) {
                    sessionStorage.removeItem("pressBack");
                }

                try {
                    await this.getDestinations();
                } catch (error) {
                    // Servicio de destinos caído: modal estándar con reintento en vez de pantalla vacía
                    const statusCode = error.response?.status;
                    this.Bus.$emit('show-service-fail', statusCode, [() => this.getInitData()]);
                    return;
                }

                var dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': dataTabHome ? dataTabHome.email : null,
                    'referente': this.referente,
                    'product': 'asistencia-viaje',
                    'event': 'cotizador-asistencia-viaje-destino'
                });
                window.globalThis._qsie = window.globalThis._qsie || [];
                window.globalThis._qsie.push('cotizador-asistencia-viaje-destino');

                // Restaurar la card seleccionada siempre que exista una selección previa
                // (cubre tanto el botón Volver como el botón atrás del browser)
                var productData = JSON.parse(sessionStorage.getItem("TravelDestinationSelected"));
                if (productData) {
                    this.$refs.productCards.getDataProductBack(productData);
                }

                if (pressBack) {
                    // Permite la navegación nuevamente cuando el componente regresa a este tab
                    this.$refs.productCards.resetNavigationFlag();
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();
                await this.pageCustomization();
                await this.updateByProductGoogleAnalytics();
                await this.getInitData();
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
